import React from 'react';

import IconNotPaid from '../components/icon/IconNotPaid';
import IconPaid from '../components/icon/IconPaid';

type Props = {
  status: boolean
  isFree?: boolean
  className?: string
}

export default function AttendeePaymentStatus({ status, isFree, className }: Props) {
  if (isFree) {
    return ( <div className={className}><IconNotPaid className="text-green"/> Free</div> );
  }
  if (status) {
      return ( <div className={className}><IconPaid className="text-green"/> Paid</div> );
  }
  return ( <div className={className}><IconNotPaid className="text-gray-dark"/> Not Paid</div> );
}
